<template>
  <Table
    ref="table"
    :statuses-items="easementItems"
    :layers-filters="layersFilters"
    @setLayerFeaturesFilters="setLayerFeaturesFilters"
    @deleteLayerFeaturesFilters="deleteLayerFeaturesFilters"
    :is-custom-layer="true"
    :custom-layer-data="customLayerData"
  >
    <template v-slot:additionalTools="scope">
      <v-col style="flex-grow: 0" v-for="(select, idx) of selects" :key="idx">
        <table-select v-model="scope.filters.navbar_filter[select.name]" v-bind="select" @input="changeFilters()" />
      </v-col>
    </template>
  </Table>
</template>

<script>
import { get, sync } from 'vuex-pathify';

import Table from '@/components/Table';
import TableSelect from '@/components/TableSelect';

export default {
  name: 'TableEasements',
  components: {
    Table,
    TableSelect,
  },
  computed: {
    activeTool: sync('tools/activeTool'),
    currentLayerDataSourceName: sync('layers/currentLayer@data_source_name'),
    easementStatuses: get('admin/modulesMapping@transmission_easement.statuses'),
    layerId: get('admin/modulesMapping@transmission_easement.layer_id'),
    layersFilters: get('layers/layersFilters'),
    customLayerData() {
      return {
        routeName: 'transmission_easement',
        eventName: 'toggleEasements',
        filterEventName: 'toggleEasementsFilter',
        layerId: this.layerId,
      };
    },
  },
  data: vm => ({
    filtersValues: {
      status: '',
    },
    selects: [
      {
        name: 'status',
        itemText: 'value',
        label: vm.$i18n.t('dialog.status'),
        items: [],
      },
    ],
    easementItems: [
      {
        key: 'not_established',
        color: 'rgba(0,145,234)',
        shadowColor: 'rgba(0,145,234,0.2)',
      },
      {
        key: 'established',
        color: 'rgba(24,128,56)',
        shadowColor: 'rgba(24,128,56,0.2)',
      },
      {
        key: 'establishing_in_progress',
        color: 'rgba(255,136,0)',
        shadowColor: 'rgba(255,136,0,0.2)',
      },
    ],
  }),
  methods: {
    changeFilters() {
      this.$refs.table.handleFilter();
    },
    deleteLayerFeaturesFilters(currentLayerId) {
      this.$store.set('layers/DELETE_LAYERS_FILTERS!', currentLayerId);
    },
    onLayerChanged() {
      this.$refs.table.onLayerChanged();
    },
    setLayerFeaturesFilters(filter) {
      this.$store.set('layers/SET_LAYERS_FILTERS!', filter);
    },
    setFilters(additionalTableFilterValues, isInit) {
      setTimeout(() => {
        this.$refs.table.setNavbarFilters(additionalTableFilterValues, isInit);
      });
    },
  },
  beforeCreate() {
    this.$once('hook:beforeDestroy', () => {
      this.$nextTick(() => {
        this.activeTool = undefined;
      });
      this.$root.$emit('toggleEasements', false);
    });
  },
  created() {
    this.$root.$off('setAdditionalTableFilterValues');
    this.$root.$on('setAdditionalTableFilterValues', this.setFilters);
  },
  beforeMount() {
    this.selects.find(select => select.name === 'status').items = this.easementItems.map(item => {
      item.value = this.easementStatuses[item.key];
      return item;
    });
  },
  mounted() {
    const additionalTableFilterValues = this.$route.params.additionalTableFilterValues;
    if (additionalTableFilterValues) {
      this.setFilters(additionalTableFilterValues, true);
    }
  },
};
</script>
